export default __webpack_public_path__ + "static/media/penguin-3.edded42b.png";